__turbopack_context__.v({
  "card": "WhyAmity-module-scss-module__kPYWZq__card",
  "cardDesc": "WhyAmity-module-scss-module__kPYWZq__cardDesc",
  "cardSubtitle": "WhyAmity-module-scss-module__kPYWZq__cardSubtitle",
  "cardTitle": "WhyAmity-module-scss-module__kPYWZq__cardTitle",
  "cardTop": "WhyAmity-module-scss-module__kPYWZq__cardTop",
  "card_container": "WhyAmity-module-scss-module__kPYWZq__card_container",
  "carousel_container": "WhyAmity-module-scss-module__kPYWZq__carousel_container",
  "container": "WhyAmity-module-scss-module__kPYWZq__container",
  "divider": "WhyAmity-module-scss-module__kPYWZq__divider",
  "header": "WhyAmity-module-scss-module__kPYWZq__header",
  "headerLeft": "WhyAmity-module-scss-module__kPYWZq__headerLeft",
  "icon": "WhyAmity-module-scss-module__kPYWZq__icon",
  "mainTitle": "WhyAmity-module-scss-module__kPYWZq__mainTitle",
  "tagline": "WhyAmity-module-scss-module__kPYWZq__tagline",
  "topCta": "WhyAmity-module-scss-module__kPYWZq__topCta",
  "wrapper": "WhyAmity-module-scss-module__kPYWZq__wrapper",
});
